// Estado con el que el NuevoPedido original crea el pedido (envasado_pedidos.estado).
export const ESTADO_INICIAL_PEDIDO = 245;

// Tipo de pedido que envía el original.
export const TIPO_PEDIDO = 1;

// Opciones del selector de filtros de búsqueda de direcciones.
export const OPCIONES_FILTROS = [
  { value: "cliente", label: "👤 Cliente", icon: "👤" },
  { value: "direccion", label: "🏠 Dirección", icon: "🏠" },
  { value: "localidad", label: "🏙️ Localidad", icon: "🏙️" },
  { value: "telefono", label: "📞 Teléfono", icon: "📞" },
  { value: "cuit", label: "📋 CUIT", icon: "📋" },
  { value: "sisven", label: "🔢 SISVEN", icon: "🔢" },
];

export const FILTROS_INICIALES = ["cliente", "direccion"];
